import { TagManagerWrapper } from '.';
import { TGtagInitConfig } from './types';

// Subclass for Google Ads
export class GoogleAdsWrapper extends TagManagerWrapper {
  constructor(dataLayerName = 'gadsLayer', gtagFunctionName = 'gadsTag') {
    super(dataLayerName, gtagFunctionName);
  }

  public initGoogleAds(
    adsConversionId: string,
    googleTagId: string,
    custom_domain: string,
    config: TGtagInitConfig = {},
  ): void {
    if (!this.isValidId(adsConversionId, /^AW-/)) {
      throw new Error('Invalid Google Ads Conversion ID');
    }
    this.loadGtagScript(adsConversionId, googleTagId);
    this.gtagFunction('config', adsConversionId, {
      allow_enhanced_conversions: true,
      transport_url: custom_domain ?? undefined,
      ...config,
    });
    this.initConsent();
  }
}
